import React, { Component } from 'react'
import PropTypes from "prop-types";
import clsx from "clsx";

/**
 * 
 */
export default class Alert extends Component {
  static propTypes = {
    msg: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.func]),
    subline: PropTypes.string,
    color: PropTypes.oneOf(["green", "red"])
  }

  static defaultProps = {
    color: "green"
  }

  render() {
    if (!this.props.msg) return null;
    let { msg } = this.props;

    if (typeof msg === "function") {
      msg = msg();
    } 

    return (
      <div className={clsx(["alert", this.props.color])}>
        {Array.isArray(msg)
          ? msg.map(m => <h4>- {m}</h4>)
          : <h4>{msg}</h4>}
        {this.props.subline && <p>{this.props.subline}</p>}
      </div>
    )
  }
}